/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { syncProductHasVariants } from './helpers/productVariantsHelpers';

export const createOption = createAsyncThunk(
  'products/createOption',
  async ({ productId, name, values }, {
    extra: { Logger, Toast, sdk },
  }) => {
    try {
      const { data } = await sdk.products.addOption(productId, name, values);
      return data;
    } catch (error) {
      Logger.log('UI', 'ToastCannotAddOption');
      Toast(
        'Option is not created. Refresh and try again',
        { autoClose: false, type: 'error' },
      );
      Logger.error(new Error('Error option adding'), { error }, [
        'CreateOptionFailed',
        { errorMessage: 'Option is not created on the backend.' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    createOption.pending,
    (state, { meta }) => {
      state.items.forEach((product) => {
        if (product._id === meta.arg.productId) {
          product.isBusy = true;
        }
      });
    },
  ).addCase(
    createOption.fulfilled,
    (state, { payload, meta }) => {
      state.items = state.items.map((product) => {
        if (product._id === meta.arg.productId) {
          const updatedProduct = {
            ...product,
            isBusy: false,
            variants: payload.variants,
            availableOptions: payload.availableOptions ?? [
              ...(product.availableOptions || []),
              payload.option,
            ],
            hasVariants: payload.hasVariants ?? product.hasVariants,
          };
          if (payload.hasVariants == null) {
            syncProductHasVariants(updatedProduct);
          }
          return updatedProduct;
        }
        return product;
      });
    },
  ).addCase(
    createOption.rejected,
    (state, { meta, error }) => {
      state.items.forEach((product) => {
        if (product.baseProductId === meta.arg.productId) {
          product.isBusy = false;
        }
      });
      state.error = error;
    },
  );
};
